export default "/_next/static/images/450b21797193f45a10c94e353cd94256.png";